import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// img
import v1 from "../../../../Assets/images/v1.png";

// css
import styles from "./serviceDetail.module.scss";
import Slider from "react-slick";
import { GET_SERVICE_BY_ID } from "../../../../services/ApiCalls";

const ServiceDetail = () => {
  const [serviceDatas, setServiceDatas] = useState({});
  const { id } = useParams();
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };
  const getService = async (id) => {
    try {
      const serviceRes = await GET_SERVICE_BY_ID(id);
      console.log(serviceRes, "servicedata");
      if (serviceRes.status === 200) {
        const data = serviceRes?.data?.data;
        setServiceDatas(data);
      } else {
        toast.error(serviceRes?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getService(id);
  }, [id]);
  return (
    <>
      <section
        className={`${styles.ServiceDetail} ServiceDetail py-3 position-relative`}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <Link to="/vehicle" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width=" 1"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            {/* Modal for Image Preview */}
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header closeButton>
                {/* <Modal.Title>Image Preview</Modal.Title> */}
              </Modal.Header>
              <Modal.Body className="text-center">
                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Document Preview"
                    className="img-fluid"
                    style={{ maxHeight: "500px" }}
                  />
                )}
              </Modal.Body>
            </Modal>
            <Col lg="6" className="my-2">
              <div className="box cardCstm p-3 px-lg-4 position-relative">
                <Form>
                  <Row className="justify-content-center">
                    <Col lg="12" className="my-2">
                      <div className={`${styles.featuredImage} featuredImage`}>
                        <Slider {...settings}>
                          <img
                            src={serviceDatas?.image}
                            alt=""
                            // className={`img-fluid w-100 object-fit-contain`}
                            // className="img-fluid"
                            style={{ maxHeight: "500px", width: "500px" }}
                            className="img-fluid object-fit-contain"
                            onClick={() =>
                              handleImageClick(serviceDatas?.image)
                            }
                          />
                        </Slider>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Vehicle Name
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {serviceDatas?.name}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Vehicle Type
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {serviceDatas?.type}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Service Base Fare
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            ${serviceDatas?.baseFareforservice}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Per Miles Price
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            ${serviceDatas?.perDistancemiles}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Weight Capacity(lb)
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {serviceDatas?.weightCapacity}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Description
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {serviceDatas?.shortDesc?.charAt(0).toUpperCase() +
                              serviceDatas?.shortDesc?.slice(1)}
                          </p>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ServiceDetail;
